import React, { useEffect, useState } from 'react';
import Modal from './Modal.js';
import Text from '../Text.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';

/**
 * 
 * @returns 
 */
const RemoveDependent = ({
  open,
  dependentInfo,
  goBack,
  openChangeRequestModal
}) => {
  const [dependent, setDependent] = useState({
    firstname: '',
    lastname: ''
  });
  useEffect(() => {
    setDependent({
      firstname: dependentInfo?.firstname,
      lastname: dependentInfo?.lastname
    });
  }, [dependentInfo]);

  /**
   * Resets the form to its initial state.
   */
  const resetForm = () => {
    setDependent({
      firstname: '',
      lastname: ''
    });
  };

  /**
   * Closes the modal and resets the form.
   */
  const close = () => {
    resetForm();
    goBack();
  };

  /**
   * 
   * @returns 
   */
  const createChangeRequest = () => {
    const changeRequestData = {
      type: 'Remove a Dependent',
      details: {
        dependentID: dependentInfo.dependentID
      }
    };
    openChangeRequestModal(changeRequestData);
    close();
    return true;
  };
  return /*#__PURE__*/React.createElement(Modal, {
    open: open,
    onClose: close,
    title: i18n.t(tokens.titles.removeDependent),
    primaryButton: {
      label: i18n.t(tokens.buttons.terminateDependent),
      onClick: createChangeRequest
    }
  }, dependent.firstname ? /*#__PURE__*/React.createElement(Text, {
    marginTop: 20
  }, i18n.t(tokens.labels.dependents.areYouSureYouWantToRemoveThisDependent, {
    dependentName: `${dependent.firstname} ${dependent.lastname}`
  })) : null);
};
export default RemoveDependent;